$(document).ready(function () {
    if (sid) {
        activeCart.getCartInfo(true);
    }

    activeCart.presetup();
    /**
     * function handling the multiselect
     */
    $('.cartSelCheckbox').change(function () {
        var id = this.id.split('-')[1];
        var position = $("input[name*='choose_positions_" + id + "']");

        if (position) {
            position.val(this.checked ? "Y" : '');
        }

        DIG.util.CartUtil.getCheckedItems();
    })
})

var activeCart = {
    mode: '',
    config: {},
    presetup: function () {
        if (this.mode === 'missingInput') {
            $('#submitCartBtn').addClass('btn-light').removeClass('btn-primary');
        }
    },
    selectAll: function () {

        $(".selectAllCheckbox").toggleClass('hidden');
        if (!this.config.checkedAll)
            this.config.checkedAll = 'checked';
        else
            this.config.checkedAll = null;

        $(".cartSelCheckbox").attr("checked", this.config.checkedAll);
        $(".cartSelCheckboxHidden").val(this.config.checkedAll == 'checked' ? "Y" : '');

        DIG.util.CartUtil.getCheckedItems();
    },
    fieleUpload: function (cartarticleId, ignoreType) {
        $('#attUpload-' + cartarticleId).removeClass('hidden');
        ExtArray = window['extArray' + cartarticleId];
        if (document.cartform['new_attachment' + cartarticleId].value == '') {
            notification.warning(output.e_upload_file_not_chosen);
        } else if (ignoreType || filetypeOK(document.cartform['new_attachment' + cartarticleId], ExtArray)) {

            notification.info(output.t_data_beeing_loaded);


            document.cartform.saveuploadattachment.value = 'Y';
            document.cartform.attachmentuploadcartarticleid.value = cartarticleId;
            // document.cartform.updatecartlocationid.value = 'Y';
            document.cartform.save_the_ud_fields.value = 'Y';

            if (document.cartform.update_investment)
                document.cartform.update_investment.value = 'Y';

            setTimeout(function () {
                submitFormGreyOut(document.cartform);
            }, 500);

        }
        return false;
    },
    minimise: function (id) {
        if (id == 'all') {
            $('.articleRow').each(function (index) {
                $(this).removeClass('artRowExpanded').addClass('articleRowMin');
            })
        } else {
            $('#artId-' + id).removeClass('artRowExpanded').addClass('articleRowMin');
        }
    },
    expand: function (id) {
        if (id == 'all') {
            $('.articleRow').each(function (index) {
                $(this).removeClass('articleRowMin').addClass('artRowExpanded');
            })
        } else {
            $('#artId-' + id).removeClass('articleRowMin').addClass('artRowExpanded');
        }
    },
    preSubmitCheck: function (clickObject) {
        if (this.config.validateDeliveryText && typeof(document.cartform.deliverytext) !== 'undefined' && document.cartform.deliverytext.value == '') {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.validateDeliveryText);
            if (clickObject != null) {
                clickObject.onclick = function () {
                    activeCart.submitCart(this)
                }
            }
            return false;
        }
        if (this.pageStillLoading())
            return false;

        if (this.config.updateStocks) {
            disablePageOnReload(this.config.updateStocks);
            document.cartform.artnrs.value = this.config.stockCount;
        }
        if (!this.checkSap(clickObject)) {
            return false;
        }
        if (!this.specificApprovalManager()) {
            return false;
        }
        if (activeCart.config.choosePositionsEnabled && !DIG.util.CartUtil.getCheckedItems()) {
            notification.error(activeCart.config.noPossesionSelectedMsg)
            return false;
        }

        if (this.config.checkbox_conditions_for_dsvgo) {
            if (!this.dsvgoCheck(clickObject)) {
                return false;
            }
        }

        if (this.config.checkbox_conditions_for_purchasing) {
            if (!this.purchasingConditionsCheck(clickObject)) {
                return false;
            }
        }

        $('#submitCartBtn').addClass('btn-primary').removeClass('btn-light');
        return true;
    },
    securityLetterPrompt: function (clickObject) {
        var text = this.config.securityLetter.message + ':\n';
        $.each(this.config.securityLetter.article, function (key, article) {
            text += "<br> - " + article.name + " <a target='_blank' href='" + article.url + "'>" + article.securityName + "</a>\n";
        });

        notification.promptCustomYesNo(
            this.config.securityLetter.header + "!",
            text,
            this.config.securityLetter.okBtn,
            output['b_abbrechen'],
            function (){
                delete activeCart.config.securityLetter;
                activeCart.submitCart(clickObject);
            }
        )
    },
    submitCart: function (clickObject) {

        if (this.config.securityLetter) {
            this.securityLetterPrompt(clickObject);
            return;
        }


        if (this.preSubmitCheck(clickObject)) {
            disablePageOnDataLoad();
            if(this.mode == ''){
               return  notification.info('permission error');
            }else{
               return this[this.mode](clickObject);
            }
        }
    },
    submitCheckOut: function () {
        if (this.preSubmitCheck())
            gotoCheckOut();
    },
    cartSubmitOk: function (clickObject) {
        submitCartOrder('none', 'ordertrack', clickObject);
        if (clickObject != null) {
            clickObject.onclick = null;
        }
        return false;
    },
    ociCheckout: function () {
        gotoOCICheckOut(this.config.ocicheckoutEncoding);
        return false;
    },
    goToSecurityCertificate: function (clickObject) {
        DIG.util.CartUtil.gotoSicherheitsdatenblatt();
        if (clickObject != null) {
            clickObject.onclick = null;
        }
        return false;
    },
    missingInput: function () {
        enablePageOnReload();
        enablePage();
        enablePageOnDataLoad();
        notification.error(this.config.missingMessage);
        return false;
    },
    bankAmmountCheck: function (clickObject) {
        if ((this.config.helvetiaCheck && document.cartform.accept_conditions_for_purchasing && !document.cartform.accept_conditions_for_purchasing.checked) || (document.cartform.accept_bank_collection && !document.cartform.accept_bank_collection.checked)) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.missingMessage);
            return false;
        }
        return this.cartSubmitOk(clickObject);
    },
    dsvgoCheck: function (clickObject) {
        if (document.cartform.accept_conditions_for_dsvgo && !document.cartform.accept_conditions_for_dsvgo.checked) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.check_conditions_for_dsvgo_missing);
            return false;
        }
        return true;
    },
    purchasingConditionsCheck: function (clickObject) {
        if (document.cartform.accept_conditions_for_purchasing && !document.cartform.accept_conditions_for_purchasing.checked) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.check_conditions_for_dsvgo_missing);
            return false;
        }
        return true;
    },
    cartSubmitPoints: function (clickObject) {
        if (document.cartform.additional_benefit_taxes.checked) {
            return this.cartSubmitOk(clickObject);
        } else {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.missingMessage);
            return false;
        }
    },
    ociValidate: function () {
        var style = 'width=400,height=400,resizable=no,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no';
        window.open('validate.phtml?sid=' + sid + '&cartartidlist=' + this.config.validatecartartidlist, 'cartFeatures', style);
    },
    pageStillLoading: function () {
        if (typeof (document.readyState) == 'undefined' || document.readyState !== 'complete') {
            alert(this.config.pageStillLoading);
            return true;
        }
        return false;
    },
    specificApprovalManager: function () {
        if (!DIG.util.CartUtil.specificApprovalManager(this.config.specificApprovalManager, this.config.cartLocationId, this.config.regionManagers)) {
            enablePageOnDataLoad();
            notification.error(this.config.noApprovalManager)
            return false;
        }
        return true;
    },
    forceWaitForPriceUpdate: function () {
        if (pricesAlreadyUpdated() == false) {
            $('#tableInfo').show();
            return false;
        }
        this.submitCheckOut();
    },
    approvalGroupsEnabled: function (clickObject) {
        if ((typeof document.cartform.type_of_acquisition) !== 'undefined' && document.cartform.type_of_acquisition.value == '') {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.noDeliverySet);
            if (clickObject != null) {
                clickObject.onclick = function () {
                    activeCart.submitCart(this)
                }
            }
            return false;
        }
        if ((typeof document.cartform.cart_business_unit_id) !== 'undefined' && document.cartform.cart_business_unit_id.value == '') {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.noDeliveryUnitSet);
            if (clickObject != null) {
                clickObject.onclick = function () {
                    activeCart.submitCart(this)
                }
            }
            return false;
        }
        if ((typeof document.cartform.cart_region_id) !== 'undefined' && document.cartform.cart_region_id.value == '') {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.noRegionSet);
            if (clickObject != null) {
                clickObject.onclick = function () {
                    activeCart.submitCart(this)
                }
            }
            return false;
        }

        /*
        if (document.cartform.cart_function_id.value == '') {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.noFunctionSet);
            if (clickObject != null) {
                clickObject.onclick = function () {
                    activeCart.submitCart(this)
                }
            }
            return false;
        }

         */
        this.submitCheckOut();
    },
    securityLetter: function (clickObject) {
        if (!DIG.util.CartUtil.alternativeReceiverOK(this.config.mondatoryReciever)) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.emptyReciever);
            return false;
        }
        if (!DIG.util.CartUtil.commentOK(this.config.mondatoryComment)) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.emptyComment);
            return false;
        }
        document.cartform.showsicherheitsdatenblatt.value = 'Y';
        if (clickObject != null) {
            clickObject.onclick = null;
        }
        this.submitCheckOut();
    },
    simulateCart: function (clickObject) {
        if (!DIG.util.CartUtil.alternativeReceiverOK(this.config.mondatoryReciever)) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.emptyReciever);
            return false;
        }
        if (!DIG.util.CartUtil.commentOK(this.config.mondatoryComment)) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.emptyComment);
            return false;
        }
        disablePageOnReload(this.config.simulateCartMessage);
        replaceOnLoadGIF();

        if (clickObject != null) {
            clickObject.onclick = null;
        }
        this.submitCheckOut();
    },
    goToAssignments: function (clickObject) {
        if (!DIG.util.CartUtil.alternativeReceiverOK(this.config.mondatoryReciever)) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.emptyReciever);
            if (clickObject != null) {
                clickObject.onclick = function () {
                    activeCart.submitCart(this)
                }
            }
            enablePageOnDataLoad();
            return false;
        }
        if (!DIG.util.CartUtil.commentOK(this.config.mondatoryComment)) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.emptyComment);
            if (clickObject != null) {
                clickObject.onclick = function () {
                    activeCart.submitCart(this)
                }
            }
            enablePageOnDataLoad();
            return false;
        }
        replaceOnLoadGIF();
        if (clickObject != null) {
            clickObject.onclick = null;
        }
        this.submitCheckOut();
    },
    checkSap: function (clickObject) {
        if (!this.config.sapRequired) {
            return true;
        }
        var me = this;
        me.callbackOk = function (data) {
            for (var key in data.results) {
                if (data.results.hasOwnProperty(key)) {
                    if (data.results[key].error) {
                        $('#buyerAid-' + data.results[key].id).text(data.results[key].error);
                    } else {
                        $('#buyerAid-' + data.results[key].id).text(data.results[key].value);
                    }
                }
            }
            if (data.success) {
                gotoCheckOut();
            } else {
                classicErrrorMessage('SAP Materialnummer Check fehlgeschlagen');
                if (clickObject != null) {
                    clickObject.onclick = function () {
                        activeCart.submitCart(this)
                    };
                }
                return false;
            }
        };
        me.callbackFail = function (data) {
            classicErrrorMessage('SAP Materialnummer Check Fehler.');
            if (clickObject != null) {
                clickObject.onclick = function () {
                    activeCart.submitCart(this)
                };
            }
            return false;
        };
        if ($('.buyerAidUpdate').length > 0) {

            var data = [];
            var ok = true;
            $('.buyerAidUpdate').each(function (index, item) {
                // EAG SAP Matnr is optional
                // if (item.value.length == 0) {
                //     ok = false;
                //     $(item).focus();
                // }
                data.push({
                    id: $(item).data('id'),
                    value: item.value
                });
            });
            if (!ok) {
                enablePageOnReload();
                enablePage();
                enablePageOnDataLoad();
                notification.error(this.config.sapRequired)
            } else {
                //this.onclick = '';
                classicErrrorMessage('SAP Material-Number check...');
                AjaxHandlerByClass('ajax/Approval/Article/sapCheck', data, me.callbackOk, me.callbackFail);
            }
        }
        return false;
    },
    checkArticleSap: function (articleId) {
        var me = this;
        me.callbackOk = function (data) {
            for (var key in data.results) {
                if (data.results.hasOwnProperty(key)) {
                    if (data.results[key].error) {
                        $('#buyerAid-' + data.results[key].id).text(data.results[key].error);
                    } else {
                        $('#buyerAid-' + data.results[key].id).text(data.results[key].value);
                    }
                }
            }
            classicErrrorMessage('');
        }
        me.callbackFail = function () {
            notification.error('SAP Materialnummer Check Fehler.');
            return false;
        };
        var value = $("input[name='buyer_aid_update[" + articleId + "]']").val();
        if (!value) {
            enablePageOnReload();
            enablePage();
            enablePageOnDataLoad();
            notification.error(this.config.sapRequired)
            return false;
        }
        classicErrrorMessage('SAP Material-Number check...');
        AjaxHandlerByClass('ajax/Approval/Article/sapCheck', [{
            id: articleId,
            value: value
        }], me.callbackOk, me.callbackFail);
    },

    getCartInfo: function (forceCalculation) {
        AjaxHandlerByClass('ajax/ArticleSearch/ActiveCart/getCartInfo', {forceCalculation: forceCalculation}, function (data) {
            var cartInfo = $(".badge-notify");
            if (data.articleCount > 0 && cartInfo) {
                cartInfo.html(data.articleCount).show();
                $('#cart-summ-info').html(data.cartCurrency + ' ' + data.cartSum);
            } else {
                cartInfo.hide();
            }
        }, function () {
        });
    },
    setCartInfo: function (data) {
        $(".badge-notify").html(data.cartarticlecount).show();
        $('#cart-summ-info').html(data.currency + ' ' + data.cartsum_net);
    },
    deleteArticle: function (articleId) {
        if (articleId == 'all_cart') {
            var delIds = [];
            $('.cartSelCheckbox').each(function () {
                if (this.checked)
                    delIds.push(this.id.split('-')[1]);

            });

            return notification.confirm(
                output["t_sind_sie_sicher_dass_sie_diese_positionen_loeschen_wollen"],
                function () {
                    delArticlesFromCart(delIds.join(';'));
                }
            );
        } else if (articleId == 'all_positions_with_cart_checkbox') {
            var delIds = [];
            $('.cartSelCheckbox').each(function () {
                if (this.checked)
                    delIds.push(this.id.split('-')[1]);

            });

            return notification.promptConfirmation(
                output["t_sind_sie_sicher_dass_sie_diese_positionen_loeschen_wollen"],
                function () {
                    delArticlesFromCart(delIds.join(';'));
                },
                output["b_warenkorb_leeren"],
                function () {
                    document.deletecart.submit();
                }
            );
        } else {
            return notification.confirm(
                output["t_sind_sie_sicher_dass_sie_diese_position_loeschen_wollen"],
                function () {
                    delArticlesFromCart(articleId);
                });
        }
    },
    delCountry: function (submitId) {
        return notification.confirm(
            output["t_sind_sie_sicher_dass_sie_diese_position_loeschen_wollen"],
            function () {
                elem = document.pageForm;
                if (!elem) {
                    elem = document.getElementById('quicksearch');
                }
            })
    },
    assignFreetextSellerToAllFreetextPositions: function(articleId) {
        console.log(output["t_sind_sie_sicher_dass_sie_alle_freitext_positionen_ueberschreiben_wollen"]);
        return notification.confirm(
            output["t_sind_sie_sicher_dass_sie_alle_freitext_positionen_ueberschreiben_wollen"],
            function () {
                assignFreetextSellerToAllFreetextPositions(articleId);
            }
        );
    }
}


